var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInicioSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 38,
    viewBox: "0 0 43 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.464 36.954V24.537H17.796V36.954H9.478C8.55596 36.9684 7.66591 36.6162 7.00343 35.9747C6.34096 35.3332 5.96026 34.455 5.945 33.533V20.99H3.041C2.63379 20.9898 2.23632 20.8654 1.90174 20.6333C1.56715 20.4011 1.3114 20.0724 1.16865 19.691C1.02591 19.3097 1.00298 18.8938 1.10293 18.4991C1.20289 18.1043 1.42096 17.7495 1.728 17.482L19.941 1.61197C20.3052 1.29459 20.7719 1.11975 21.255 1.11975C21.7381 1.11975 22.2048 1.29459 22.569 1.61197L40.782 17.482C41.0891 17.7495 41.3072 18.1044 41.4071 18.4993C41.5071 18.8941 41.484 19.3101 41.3412 19.6915C41.1983 20.0729 40.9424 20.4016 40.6076 20.6337C40.2729 20.8657 39.8753 20.99 39.468 20.99H36.568V33.532C36.5606 33.9889 36.4632 34.44 36.2814 34.8593C36.0996 35.2786 35.837 35.658 35.5085 35.9758C35.18 36.2936 34.7922 36.5435 34.3671 36.7114C33.942 36.8792 33.488 36.9617 33.031 36.954H25.464Z",
    stroke: "#000FFF",
    strokeWidth: 2,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.509,
    height: 37.953,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInicioSelected);
export default __webpack_public_path__ + "static/media/ic_inicio_selected.ec2105deb9e7b88791012a4334a10d2a.svg";
export { ForwardRef as ReactComponent };